import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { withContext } from '@piggybank/core';
import { Consumer } from '../Wizard/context.js';

var WizardPage = function WizardPage(_ref) {
  var children = _ref.children,
      Component = _ref.component,
      handleSubmit = _ref.handleSubmit,
      navigateTo = _ref.navigateTo,
      setInitialValues = _ref.setInitialValues,
      values = _ref.values,
      props = _objectWithoutProperties(_ref, ["children", "component", "handleSubmit", "navigateTo", "setInitialValues", "values"]);

  var contentProps = {
    handleSubmit: handleSubmit,
    navigateTo: navigateTo,
    setInitialValues: setInitialValues,
    values: values
  };
  var content = children;

  if (Component) {
    content = React.createElement(Component, contentProps);
  }

  if (typeof children === 'function') {
    content = children(contentProps);
  }

  return React.createElement("div", props, content);
};

WizardPage.propTypes = process.env.NODE_ENV !== "production" ? {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /** docgen-from-context:<Wizard/> */
  handleSubmit: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  navigateTo: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  setInitialValues: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  values: PropTypes.object,
  name: PropTypes.string
} : {};
var WizardPage$1 = withContext(Consumer, function (value) {
  return {
    handleSubmit: value.handleSubmit,
    navigateTo: value.navigateTo,
    setInitialValues: value.setInitialValues,
    values: value.values
  };
})(WizardPage);
export default WizardPage$1;
export { WizardPage };